import { EramSectorTrack, } from "@poscon/shared-types/eram";
import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
export const useRootSelector = useSelector;
export const stcaPairsSelector = (state) => state.tracks.stcaPairs;
export const stcaTracksSelector = createSelector(stcaPairsSelector, (pairs) => [...new Set(pairs.flat())]);
export const suppressedConflictPairsSelector = (state) => state.tracks.suppressedConflictPairs;
export const flightplansSelector = (state) => state.tracks.flightplans;
export const flightplanSelector = (state, fpId) => (fpId ? (state.tracks.flightplans[fpId] ?? null) : null);
export const tracksSelector = (state) => state.tracks.tracks;
export const trackSelector = (state, trackId) => trackId in state.tracks.tracks ? state.tracks.tracks[trackId] : null;
export const sectorTracksSelector = (state) => state.tracks.sectorTracks;
export const sectorTrackSelector = createSelector([sectorTracksSelector, (state, trackId) => trackId], (sectorTracks, trackId) => sectorTracks[trackId] ?? new EramSectorTrack(trackId));
export const quicklookedTracksSelector = (state, trackId) => state.tracks.quicklookTracks[trackId];
export const coordinationDataSelector = (state) => state.tracks.coordinationData;
export const trackCoordinationDataSelector = createSelector([coordinationDataSelector, (state, trackId) => trackId], (coordinationData, trackId) => coordinationData[trackId] ?? {});
export const cpdlcSessionsSelector = (state) => state.tracks.cpdlcSessions;
export const terminatedCpdlcSessionsSelector = (state) => state.tracks.terminatedCpdlcSessions;
export const cpdlcSessionSelector = (state, fpId) => state.tracks.cpdlcSessions[fpId];
export const trackFromFpIdSelector = createSelector([tracksSelector, (_, fpId) => fpId], (tracks, fpId) => {
    const track = Object.values(tracks).find((track) => track.fpId === fpId);
    return track ?? null;
});
export const flightplanFromCallsignSelector = createSelector([flightplansSelector, (state, callsign) => callsign], (flightplans, callsign) => {
    const fp = Object.values(flightplans).find((fp) => fp.callsign === callsign);
    return fp ?? null;
});
export const hasCpdlcSessionSelector = createSelector([cpdlcSessionsSelector, (state, fpId) => fpId], (cpdlcSessions, fpId) => fpId in cpdlcSessions);
//# sourceMappingURL=stateSelectors.js.map